/**
 * Hook for managing deal creation fields (Settings > Workspace > Deals > Deal Fields)
 *
 * Now backed by DealFieldsContext for shared state between settings and dialogs.
 * Falls back to independent state if context is not available.
 */

import { useDealFieldsContext } from '@/contexts/DealFieldsContext';
import type { DealField, CustomFieldOption } from '@/contexts/DealFieldsContext';

export type { DealField, CustomFieldOption };

export function useDealFields() {
  return useDealFieldsContext();
}
